import React from "react";
import { Formik, Form } from "formik";
import { Container } from "react-bootstrap";
import Swal from "sweetalert2";
import { useDispatch } from "react-redux";
import { AddMarca } from "../../Api/Marcas.Api";
import { useNavigate } from "react-router-dom";

export const FormAddMarca = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return (
    <Container>
      <Formik
        initialValues={{
          ma_desc: "",
        }}
        onSubmit={(values) => {
          Swal.fire({
            title: "Agregar Marca?",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Agregar!",
          }).then((result) => {
            if (result.isConfirmed) {
              (async (_) => {
                dispatch(AddMarca(values)).then((res) => {
                  if (res.meta.requestStatus === "fulfilled") {
                    Swal.fire({
                      icon: "success",
                      toast: true,
                      position: "top-end",
                      text: "Marca Agregada",
                      timer: 2800,
                      showConfirmButton: false,
                    });
                    navigate("/Marcas");
                  } else {
                    Swal.fire({
                      icon: "info",
                      title: "Respuesta del Servidor",
                      text: "Vuelve a Iniciar sessión, si persiste el problema contáctanos",
                    });
                  }
                });
              })();
            }
          });
        }}
      >
        {({ handleChange }) => (
          <Form
            style={{ display: "flex", flexDirection: "column", gap: "8px" }}
          >
            <input
              type="text"
              name="ma_desc"
              placeholder="Nombre Marca"
              onChange={handleChange}
              required
            />
            <div>
              <button type="submit">Agregar</button>
            </div>
          </Form>
        )}
      </Formik>
    </Container>
  );
};
